import { IconProps } from '@tabler/icons-react-native'
import { Path, Svg } from 'react-native-svg'

export default function Frame({
  size = 24,
  strokeWidth = 2,
  color = 'black',
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M1.00024 7.60021V3.19997C1.00024 2.6165 1.23203 2.05693 1.6446 1.64436C2.05718 1.23178 2.61675 1 3.20022 1H7.60018M1 16.3998V20.8C1 21.3835 1.23178 21.9431 1.64436 22.3556C2.05693 22.7682 2.61651 23 3.19998 23H7.60018M16.4001 1H20.8C21.3835 1 21.9431 1.23178 22.3556 1.64436C22.7682 2.05693 23 2.6165 23 3.19997V7.60021M16.4001 23H20.8C21.3835 23 21.9431 22.7682 22.3556 22.3556C22.7682 21.9431 23 21.3835 23 20.8V16.3998"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
